 /**
 * Check if element is in viewport
 * @param el {HTMLElement}
 * @return {Boolean}
 */
function elementInViewport(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while(el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    return (
        top < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset
    );
};


/**
 * @description sticky product form
 * @note add [data-product-submit] to static submit button
 */
(function() {
    var forms = Array.from(document.querySelectorAll('[data-sticky-form]'));
    
    var triggerElement = document.querySelector('[data-product-submit]')
    var threshold = 500
    
    console.log({ forms })
    
    if ( forms && forms.length ) {
        forms.forEach(function(form) {
            window.addEventListener('scroll', function() {
                var nodeInViewport = elementInViewport(triggerElement)
                
                if ( !nodeInViewport && window.scrollY > threshold ) {
                    form.classList.add('visible')
                } else {
                    form.classList.remove('visible')
                }
            })
            
            var x = form.querySelector('.shopify-product-form');
            
            x.addEventListener('submit', function(e) {
                e.preventDefault();
            });
        })
    };
})();